fragment CourierFragment on Courier {
    id
    name
    updated_at
    created_at
}